import React, { useEffect, useState } from "react";
import {
  Button,
  Col, Container, Row, UncontrolledAlert,
} from "reactstrap";
import UserPOBoxDetails from "components/UserPOBoxDetails";
import UserPackageSummary from "components/UserPackageSummary";
import UserPackages from "components/UserPackages";
import { getUserData } from "utils/Session";
import styles from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import cx from "classnames";

const UserDashboard = props => {

  const navigate = useNavigate();
  const [isProfileComplete, setProfileComplete] = useState(true);

  useEffect(() => {
    checkProfileData();
  }, []);

  const checkProfileData = async () => {
    const userData = await getUserData();
    if (
      userData.id &&
      userData.attributes["custom:delivery_type"] &&
      userData.attributes["custom:tel_mobile"]
    ) {
      setProfileComplete(true);
    } else {
      setProfileComplete(false);
    }
  }

  return (
    <>
      <Container className={cx([styles.mainContainer])}>
        <Row className="justify-content-center">
          {!isProfileComplete && (
            <Col sm={8}>
              <UncontrolledAlert color="warning">
                <div className={styles.alertContainer}>
                  ¡Completa tu perfil ahora! Agrega tu información de contacto y una dirección de entrega por defecto para disfrutar de la mejor experiencia en nuestra plataforma.
                  <br />
                  <Button
                    className="float-end mt-1"
                    type="submit"
                    color="primary"
                    onClick={(e) => navigate("/user/profile")}>
                    Completar Perfil
                  </Button>
                </div>
              </UncontrolledAlert>
            </Col>)
          }
        </Row>
        <Row>
          <Col lg={5} xxl={4}>
            <UserPOBoxDetails />
          </Col>
          <Col>
            <UserPackageSummary className={styles.mainCard} />
          </Col>
        </Row>
      </Container>
      <UserPackages />
    </>
  );
}

export default UserDashboard;
